module.exports = __webpack_public_path__ + "img/bank-submit.84c85945.png";